exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".program-form__label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 4px;\n}\n\n.program-form__model {\n  margin: 0;\n  padding: 8px 0;\n}\n\n.program-form__loading {\n  text-align: center;\n  padding: 16px 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/modals/scheduler-task-program-form/scheduler-task-program-form.component.css
// module id = ../../../../../src/app/shared/components/modals/scheduler-task-program-form/scheduler-task-program-form.component.css
// module chunks = main